import { render } from "./LandingSuccess.vue?vue&type=template&id=3d543ddc&scoped=true"
import script from "./LandingSuccess.vue?vue&type=script&lang=js"
export * from "./LandingSuccess.vue?vue&type=script&lang=js"

import "./LandingSuccess.vue?vue&type=style&index=0&id=3d543ddc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d543ddc"]])

export default __exports__